import { tget } from '../../utils/Utils/Utils';

export function actionRetriveCurrentUserInfo() {
  return (dispatch) => {
    return tget('/api/v3/app/user/current').then((res) => {
      dispatch({ type: 'USER_INFO', payload: res });
    });
  };
}
